module.exports = __webpack_public_path__ + "static/roadmap-mobile-cbfdb613895e154d1467713c4b1a0430.svg";